import { Grid, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { whyUsTimeLineObj } from 'assets/animation/portalAnimation';

const WhyUs: React.FC = () => {
    const whyUsTimeLine = React.useRef(null);

    React.useEffect(() => {
        whyUsTimeLineObj(whyUsTimeLine);
    }, []);

    return (
        <section className="about-us why-us" ref={whyUsTimeLine}>
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6} order={{ xs: 2, lg: 1 }}>
                        <div className="about-us-content">
                            <Typography variant="h3" color="primary" className="section-title">
                                Why Choose Healthreach
                            </Typography>
                            <Typography variant="h6" className="section-info">
                                If You Are A Patient
                            </Typography>
                            <ul>
                                <li>We aim to bridge the mental health gap for rural remote population.</li>
                                <li>Both gap and bulk billing available</li>
                                <li>
                                    See a mental health clinician without leaving the comfort of your home. 100% online
                                    service.
                                </li>
                                <li>
                                    One-stop platform for users
                                    <ul>
                                        <li className="item">Billing Reports</li>
                                        <li className="item">Payment</li>
                                        <li className="item">Appointment scheduling</li>
                                        <li className="item">Attending telehealth appointments</li>
                                        <li className="item">Medications</li>
                                        <li className="item">
                                            Access documentations including medical certifications and psychology forms
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6} order={{ xs: 1, lg: 2 }}>
                        <div className="why-us-mockup">
                            <div className="block-layer">
                                <div className="circle top"></div>
                                <div className="color-layer">
                                    <div className="frame-block calendar">
                                        <div className="svg-wrap">
                                            <img src={images.calendarIcon} alt="Icon" />
                                        </div>
                                    </div>
                                    <div className="frame-block doc-laptop">
                                        <div className="svg-wrap">
                                            <img src={images.docLaptopIcon} alt="Icon" />
                                        </div>
                                    </div>
                                    <img src={images.dashboardTwo} alt="Image" className="main-mockup" />
                                    <div className="frame-block rural">
                                        <div className="svg-wrap">
                                            <img src={images.ruralIcon} alt="Icon" />
                                        </div>
                                    </div>
                                    <div className="frame-block payment">
                                        <div className="svg-wrap">
                                            <img src={images.paymentIcon} alt="Icon" />
                                        </div>
                                    </div>
                                </div>
                                <div className="circle bottom"></div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default React.memo(WhyUs);
